import React from "react"
import styles from "./styles.scss"

const XAxisTick = ({ iconWidth }) => (
  <div className={styles.xAxisItemContainer} style={{ width: iconWidth }}>
    <div className={styles.xAxisTick} />
  </div>
)

export default XAxisTick



// WEBPACK FOOTER //
// ./src/pages/LandingPage/Chart/XAxis/XAxisTick/index.jsx